import { Box, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { loadRunningBatchList } from 'api/batch';
import { PAGINATION_DEFAULT_ROWS_PER_PAGE, PAGINATION_DEFAULT_START_PAGE } from 'attrs/pagination';
import { useEffect, useState } from 'react';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { IBatch } from 'types/interfaces/iBatch';
import BatchCard from './BatchCard';
import { HeadingWrapper, StyledMarginDiv, StyledPaper } from './RunningBatchAccordion.styled';

const RunningBatchAccordion = () => {
  const { t } = useTranslation();

  const [expanded, setExpanded] = useState(false);
  const [runningBatchList, setRunningBatchList] = useState<IBatch[]>([]);

  const onExpandClick = () => setExpanded(!expanded);

  useEffect(() => {
    async function fetchData() {
      const response = await loadRunningBatchList(PAGINATION_DEFAULT_START_PAGE, PAGINATION_DEFAULT_ROWS_PER_PAGE);
      setRunningBatchList(response.data.data);
    }

    fetchData();
  }, []);

  return (
    <>
      {runningBatchList.length ? (
        <StyledMarginDiv marginTop="20px">
          <StyledPaper elevation={3} sx={{ pl: 4, pb: '10px' }}>
            <HeadingWrapper expanded={expanded}>
              <IconButton
                data-testid="batch-records-machine-details-expand-button"
                color="primary"
                size="small"
                onClick={onExpandClick}
                style={{ marginRight: '1rem' }}
              >
                {expanded ? <IndeterminateCheckBoxOutlinedIcon /> : <AddBoxOutlinedIcon />}
              </IconButton>
              <Typography variant="caption">{t('batch_records.batches_in_operation.title')}</Typography>
            </HeadingWrapper>

            {expanded && runningBatchList.length ? (
              <Box sx={{ overflowX: 'auto', pb: 1.5 }}>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                  {runningBatchList.map(batch => (
                    <Box key={batch.id}>
                      <BatchCard batch={batch} />
                    </Box>
                  ))}
                </Box>
              </Box>
            ) : null}
          </StyledPaper>
        </StyledMarginDiv>
      ) : null}
    </>
  );
};

export default RunningBatchAccordion;
